import { Injectable } from "@angular/core";
import { ApiHttpService } from "./api-http.service";
import { Observable } from "rxjs";

@Injectable()
export class TemperatureInstructionService {
  constructor(private apiHttp: ApiHttpService) {}

  public getAll = (): Observable<TemperatureInstruction[]> => {
    return this.apiHttp.get<TemperatureInstruction[]>("temperatureinstructions");
  };

  public get = (id: number): Observable<TemperatureInstruction> => {
    return this.apiHttp.get<TemperatureInstruction>(`temperatureinstructions/${id}`);
  };
}

export interface TemperatureInstruction {
  id: number;
  name: string;
  isActive: boolean;
  requiresFollowup: boolean;
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/services/temperature-instruction.service.ts